import { useSelector } from 'react-redux'
import { RootState } from '../store/modules/rootReducer'
import { TFeatureFlags } from '../store/modules/posthog/types'

export const useFeatureFlag = <T extends TFeatureFlags>(flag: T) => {
  const { status, featureFlags, payloads } = useSelector((state: RootState) => state.posthog)

  const loading = status === 'idle'
  const isEnabled = featureFlags.includes(flag)
  const payload = loading ? null : payloads[flag]

  return { isEnabled, payload, loading }
}
